import { PrimaryButton } from "./styles";

export const Button = PrimaryButton;
